<script setup lang="ts">
    import { computed } from 'vue'
    import { SavingState } from '@common/Common'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        savingState: SavingState
        isFormSubmit?: boolean
    }>()

    const emit = defineEmits<{
        (e: 'saveChanges'): void
    }>()

    // ---------------- derived ----------------

    const buttonText = computed(() =>
    {
        switch (props.savingState)
        {
            case SavingState.InProgress:
                return 'Saving...'
            case SavingState.Pending:
                return 'Save changes'
            case SavingState.Saved:
                return 'Saved'
            default:
                return 'Save'
        }
    })

    const buttonClass = computed(() =>
    {
        switch (props.savingState)
        {
            case SavingState.InProgress:
            case SavingState.Pending:
                return 'btn-warning'
            case SavingState.Saved:
            default:
                return 'btn-success'
        }
    })

    const isButtonDisabled = computed(() =>
        props.savingState === SavingState.InProgress ||
        props.savingState === SavingState.Saved
    )

    // ---------------- methods ----------------

    function saveChanges()
    {
        if (props.isFormSubmit)
            return

        emit('saveChanges')
    }
</script>


<template>
    <button :type="isFormSubmit ? 'submit' : 'button'" :class="['btn', buttonClass]" :disabled="isButtonDisabled" @click="saveChanges" style="padding: 0.7em 2em;">
        {{ buttonText }}
    </button>
</template>